<template>
  <div class="card card-preview" v-show="enabled">
    <table class="table">
      <tbody>
      <tr v-for="item in data">
        <td>{{ item.label }}</td>
        <td>{{ item.value }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        data: []
      }
    },
    computed: {
      enabled: function () {
        return this.data.length > 0
      }
    },
    events: {
      'preview-data': function (data) {
        if (Array.isArray(data)) {
          this.data = data
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Preview.vue?153132ee